/* eslint-disable */
import '../../assets/App.scss';
import './menu.styles.css';
import '../../assets/globalStyles.css';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import CardMenu from '../../component/CardMenu';
import {home} from '../../_services';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faClipboardList, faShoppingBasket, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import NavbarBackButton from '../../component/BackButton';
import Loading from '../../component/Loading';
import {imageUrl, loadState, saveState} from '../../_helpers';
import Layout from '../../component/Layout';

function Menu() {
    let navigate = useNavigate();
    const [category, setCategory] = useState(() => {
        if (loadState('menu-sm') !== undefined) {
            return loadState('menu-sm')
        } else {
            return []
        }
    })
    const [item, setItem] = useState(() => {
        if (loadState('product-sm') !== undefined) {
            return loadState('product-sm')
        } else {
            return []
        }
    });
    const [loading, setLoading] = useState(false);
    const [menuActive, setMenuActive] = useState(0);
    const [user, setUser] = useState({
        cardNumber: "",
        sessionId: "",
        memberId: "",
        memberType: "",
        memberGroup: "",
        tableNo: ""
    })

    /**
     * Mendapatakan data locCode dan TenantName
     * @Param locCode
     * @Param tenantName
     */
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))
    useEffect(() => {
        getData()
        saveState('locCode', query.get('locationCode'))
        saveState('tenantName', query.get('name'))
        setUser({
            cardNumber: loadState('cardNumber'),
            sessionId: loadState('sessionId'),
            memberId: loadState('memberId'),
            memberType: loadState('memberType'),
            memberGroup: loadState('memberGroup'),
            tableNo: loadState('tableNo')
        })
    }, [])
    const getData = () => {
        setLoading(true)
        home.getCategory(query.get('locationCode')).then(async res => {
            let categoryList = []
            let merged = [];
            res.map(e => {
                /**
                 * Menentukan Menu
                 * jika berawalan 00 maka menu Food Festival tidak muncul
                 */
                if (e.internal_code.substring(0, 2) !== "00") {
                    home.getItem(query.get('locationCode'), e.kategori_id).then(ress => {
                        setLoading(false);
                        if(ress.length !== 0){
                            categoryList.push(e)
                            merged.push(ress);
                            setItem([...merged, ress])
                        }
                    }).catch(err => console.log(err))
                    // let navbar = document.getElementById(`header${i}`);
                    // let sticky = navbar.offsetTop;
                    // window.addEventListener('scroll', () => {
                    //     if (window.pageYOffset >= sticky) {
                    //         navbar.classList.add("sticky-category")
                    //     } else {
                    //         navbar.classList.remove("sticky-category");
                    //     }
                    // })
                }
            })
            setCategory(categoryList)
            saveState('menu-sm', categoryList)
            saveState('product-sm', merged)
            setItem(merged)

        })
    }

    const handleSelecCategory = (idx) => {
        let navbar = document.getElementById(`list${idx}`);
        navbar.scrollIntoView({behavior: "smooth"})
        setMenuActive(idx)
    }

    useEffect(() => {
        let navbar = document.getElementById(`header`);
        let sticky = navbar.offsetTop;
        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky-header")
            } else {
                navbar.classList.remove("sticky-header");
            }
        })
    }, [])

    const onExit = () => {
        navigate("/exit")
        localStorage.clear();
    }


    return (
        <Layout>
            <nav className="single-navbar level is-mobile background-pink" role="navigation"
                 aria-label="main navigation">
                <div className="level-left">
                    <NavbarBackButton/>
                    <div className="level-item">
                        <strong className="column is-size-5 has-text-white">
                            {query.get('name').length > 20 ? query.get('name').split("%20").join(" ").substring(0, 13) + "..." : query.get('name').split("%20").join(" ")}
                        </strong>
                    </div>
                </div>
                <div className="level-right px-1">
                    <div onClick={() => navigate("/payment")} className="level-item has-text-white">
                        <FontAwesomeIcon icon={faShoppingBasket} style={{fontSize: "25px"}}/>
                        {loadState('cart') !== undefined && loadState('cart').length > 0 ?
                            <span className="badge-cart">{loadState('cart').length}</span>
                            : ""}
                    </div>
                    <div
                        onClick={() => navigate('/transaction?memberId=' + user.memberId + '&memberType=' + user.memberType + '&memberGroup=' + user.memberGroup)}
                        className="level-item has-text-white">
                        <FontAwesomeIcon icon={faClipboardList} style={{fontSize: "25px"}}/>
                    </div>
                    <div className="level-item has-text-white" style={{fontSize: "25px"}}
                         onClick={() => onExit()}>
                        <FontAwesomeIcon icon={faTimesCircle}/>
                    </div>
                </div>
            </nav>

            <div className="container">
                <div style={{paddingBottom: "100px"}}>
                    {loading ? <Loading/> : null}
                    <strong className="font-size is-uppercase px-1">Menu</strong>
                    <div id="header" className="tabs">
                        <ul>
                            <li>
                                <FontAwesomeIcon className="icon-bars" icon={faBars}/>
                            </li>
                            {category.map((c, i) => (
                                <li key={i} onClick={() => handleSelecCategory(i)}
                                    className={`font-medium ${i === menuActive && "is-active"}`}>
                                    <a>{c.description}</a>
                                </li>

                            ))}
                        </ul>
                    </div>

                    {category.map((e, idx) => (
                        <div id={`list${idx}`} key={idx}>
                            <header id={`header${idx}`}>
                                <strong className="font-size pink is-uppercase px-1">{e.description}</strong>
                            </header>
                            {item[idx] !== undefined && item[idx].length > 0 ?
                                _.filter(item.flat(), (o) => o.kategori_id === e.kategori_id).map((c, i) => (
                                    <div key={i} className="px-1 py-1">
                                        <CardMenu
                                            item={c}
                                            category_name={e.description}
                                            item_id={c.item_id}
                                            foodName={c.item_name}
                                            price={c.itm_price_fmt}
                                            source={c.pic === "" ? 'https://bulma.io/images/placeholders/96x96.png' : `${imageUrl(user.memberType)}` + c.pic}
                                            available={c.rack_location !== "NONE"}
                                        />
                                        <hr/>
                                    </div>
                                )) : <p className="has-text-centered py-2">Maaf menu {e.description} belum tersedia</p>
                            }
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    );
}

export default Menu;
